import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { showImageModal } from '../../actions/image';
import SquadCard, { SquadCardType } from './SquadCard';

import data from './data';
import './SquadPage.css';

class SquadPage extends React.Component {
  static propTypes = {
    // Redux Dispatch.
    showImageModal: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.squadImage = require('../../images/about_us.jpg');
  }

  onClick = () => {
    this.props.showImageModal(this.squadImage);
  };

  render() {
    return (
      <div id="squad-page" className="squad-page content-wrapper">
        <div className="content">
          <h3>The Squad</h3>

          <img
            className="img-rounded img-responsive full-width"
            src={this.squadImage}
            alt=""
            onClick={this.onClick}
          />

          <div className="squad-group">
            <h4>Parents</h4>
            <ul>
              {data.parents.map(squad => (
                <li key={squad.name}>{squad.name}</li>
              ))}
            </ul>
          </div>

          <div className="squad-group">
            <h4>Primary Sponsors</h4>
            <ul>
              {data.primarySponsors.map(squad => (
                <li key={squad.name}>{squad.name}</li>
              ))}
            </ul>
          </div>

          <div className="squad-group">
            <h4>Bestman</h4>
            <SquadCard
              type={SquadCardType.Primary}
              squad={data.bestman}
            />
          </div>

          <div className="squad-group">
            <h4>Maid of Honor</h4>
            <SquadCard
              type={SquadCardType.Primary}
              squad={data.maidOfHonor}
            />
          </div>

          <div className="squad-group">
            <h4>Secondary Sponsors</h4>
            {data.secondarySponsorsGuys.map(squad => (
              <SquadCard
                key={squad.name}
                type={SquadCardType.Secondary}
                squad={squad}
              />
            ))}
            {data.secondarySponsorsGals.map(squad => (
              <SquadCard
                key={squad.name}
                type={SquadCardType.Secondary}
                squad={squad}
              />
            ))}
          </div>

          <div className="squad-group">
            <h4>Groomsmen</h4>
            {data.groomsmen.map(squad => (
              <SquadCard
                key={squad.name}
                type={SquadCardType.Tertiary}
                squad={squad}
              />
            ))}
          </div>

          <div className="squad-group">
            <h4>Bridesmaids</h4>
            {data.bridesmaids.map(squad => (
              <SquadCard
                key={squad.name}
                type={SquadCardType.Tertiary}
                squad={squad}
              />
            ))}
          </div>

          <div className="squad-group">
            <h4>Bearers and Flower Girls</h4>
            <ul>
              {data.bearers.map(squad => (
                <li key={squad.name}>{squad.name}</li>
              ))}
            </ul>
          </div>

        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  showImageModal,
};

export default connect(null, mapDispatchToProps)(SquadPage);



// WEBPACK FOOTER //
// ./src/components/SquadPage/index.js